import { EventList, EventCalendar, EventEdit, EventDetail } from './views'

// `/:slug` is registered LAST, after every literal segment — react-router would otherwise
// match /new, /list and /calendar as an event slug.
// Hem IS the list — `/list` stays registered as an alias so older links/bookmarks
// keep resolving; it renders the same component.
export const routesConfig = (appName, displayName) => ([
  { path: `/${appName}/new`,        element: EventEdit,     breadcrumb: 'Nytt event' },
  { path: `/${appName}/list`,       element: EventList,     breadcrumb: 'Lista' },
  { path: `/${appName}/calendar`,   element: EventCalendar, breadcrumb: 'Kalender' },
  { path: `/${appName}/:slug/edit`, element: EventEdit,     breadcrumb: 'Redigera' },
  { path: `/${appName}/:slug`,      element: EventDetail,   breadcrumb: 'Event' },
  { path: `/${appName}/`,           element: EventList,     breadcrumb: displayName },
])
